// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
import DTWorker from 'worker-loader!.';

let worker: any;

export const getWorker = () => {
  if (!worker) {
    worker = new DTWorker();
  }
  return worker;
};
